import { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@design-system';
import { REASON_TOOLTIPS, ReasonLabel } from './segments';

interface ReasonTextProps {
  reason: ReasonLabel;
  trailing?: ReactNode;
  className?: string;
}

/**
 * Renders a reason label with the explanatory tooltip the calc-derived
 * reason key carries. Trailing text (e.g. "90d total", "30d remaining")
 * stays outside the tooltip trigger so it remains plain.
 */
export function ReasonText({ reason, trailing, className }: ReasonTextProps) {
  const tip = REASON_TOOLTIPS[reason.key];
  const content = (
    <span className={className ?? `text-sm font-medium ${reason.tone}`}>
      {tip ? (
        <span className="cursor-help border-b border-dotted border-gray-400">
          {reason.text}
        </span>
      ) : (
        reason.text
      )}
      {trailing}
    </span>
  );
  if (!tip) return content;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      <TooltipContent className="max-w-xs text-xs">{tip}</TooltipContent>
    </Tooltip>
  );
}
